import React from "react";

const services = [
  {
    category: "Residential Services",
    items: [
      "Private or shared bedrooms",
      "Home-cooked meals with snacks throughout the day",
      "Housekeeping and laundry",
      "Safe, welcoming living spaces",
      "Social and recreational activities",
    ],
  },
  {
    category: "Personal Care Services",
    items: [
      "Bathing, dressing, and grooming support",
      "Toileting and incontinence care",
      "Mobility and transfer assistance",
      "Meal support when needed",
      "Medication management and administration",
      "Monitoring of ongoing health conditions",
    ],
  },
  {
    category: "Health-Related Support",
    items: [
      "Coordination with doctors, nurses, therapists, and pharmacies",
      "Transportation to medical appointments in some cases",
      "Support for specialized diets",
      "Hospice and end-of-life support when appropriate",
    ],
  },
  {
    category: "Safety and Supervision",
    items: [
      "24/7 supervision and emergency response",
      "Fall prevention and risk monitoring",
      "Prompt assistance during urgent situations",
    ],
  },
  {
    category: "Emotional and Social Support",
    items: [
      "Companionship and meaningful interaction",
      "Support for emotional well-being",
      "Encouragement of family involvement and visitation",
    ],
  },
];

export default function Services() {
  return (
    <div className="services-page">
      <section
        className="services-hero"
        style={{ backgroundImage: 'url("/images/services.jpeg")' }}
      >
        <div className="services-hero-overlay" />
        <div className="container services-hero-content">
          <span className="eyebrow">Services</span>
          <h1>Support designed around comfort, dignity, and everyday quality of life.</h1>
          <p>
            We offer attentive residential care for seniors who benefit from a
            safe environment, dependable routines, and compassionate help with
            daily living.
          </p>
        </div>
      </section>

      <section className="section-block">
        <div className="container">
          <div className="section-heading">
            <span className="eyebrow">What We Offer</span>
            <h2>Comprehensive support for residents and reassuring continuity for families.</h2>
          </div>

          <div className="service-grid">
            {services.map((section) => (
              <article key={section.category} className="service-card">
                <h3>{section.category}</h3>
                <ul>
                  {section.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section-block section-tinted">
        <div className="container cta-band">
          <div>
            <span className="eyebrow">Next Step</span>
            <h2>Questions about care, availability, or a visit?</h2>
            <p>
              Call us directly and we can talk through your loved one's needs,
              answer questions, and help you decide if Zagol Seniors Care is the
              right fit.
            </p>
          </div>
          <a className="btn btn-brand" href="tel:2064077484">
            Call 206-407-7484
          </a>
        </div>
      </section>
    </div>
  );
}
